// src/pages/LoginPage.jsx
import React from 'react';
import Login from '../components/Login';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const navigate = useNavigate();

  const handleLogin = (userData) => {
    console.log('Usuario autenticado:', userData);
    // Redirigir a la página principal después del login
    navigate('/tracking');
  };

  const handleBack = () => {
    navigate('/');
  };

  return <Login onLogin={handleLogin} onBack={handleBack} />;
};

export default LoginPage;
